import React from 'react';

const LoadingSkeleton = () => {
  return (
    <div className="mt-4 px-8 py-4 h-[80vh] flex justify-center">
      {/* Skeleton loader */}
      <div className="animate-pulse space-y-4 w-full max-w-7xl">
        {/* Header skeleton with more columns */}
        <div className="flex space-x-3 mb-6 overflow-x-hidden">
          <div className="h-8 bg-gray-200 rounded w-32"></div>
          <div className="h-8 bg-gray-200 rounded w-24"></div>
          <div className="h-8 bg-gray-200 rounded w-28"></div>
          <div className="h-8 bg-gray-200 rounded w-36"></div>
          <div className="h-8 bg-gray-200 rounded w-32"></div>
          <div className="h-8 bg-gray-200 rounded w-30"></div>
          <div className="h-8 bg-gray-200 rounded w-28"></div>
          <div className="h-8 bg-gray-200 rounded w-26"></div>
          <div className="h-8 bg-gray-200 rounded w-24"></div>
          <div className="h-8 bg-gray-200 rounded w-32"></div>
          <div className="h-8 bg-gray-200 rounded w-28"></div>
          <div className="h-8 bg-gray-200 rounded w-30"></div>
        </div>
        
        {/* Table rows skeleton with more columns */}
        {[...Array(12)].map((_, i) => (
          <div key={i} className="flex space-x-3 py-3 overflow-x-hidden">
            <div className="h-4 bg-gray-200 rounded w-32"></div>
            <div className="h-4 bg-gray-200 rounded w-24"></div>
            <div className="h-4 bg-gray-200 rounded w-28"></div>
            <div className="h-4 bg-gray-200 rounded w-36"></div>
            <div className="h-4 bg-gray-200 rounded w-32"></div>
            <div className="h-4 bg-gray-200 rounded w-30"></div>
            <div className="h-4 bg-gray-200 rounded w-28"></div>
            <div className="h-4 bg-gray-200 rounded w-26"></div>
            <div className="h-4 bg-gray-200 rounded w-24"></div>
            <div className="h-4 bg-gray-200 rounded w-32"></div>
            <div className="h-4 bg-gray-200 rounded w-28"></div>
            <div className="h-4 bg-gray-200 rounded w-30"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LoadingSkeleton;